import uuid from 'uuid/v4';
import map from 'lodash/map';
import AppStorage from '@Services/AppStorage';

const traceIdStorageKey = 'traceId';
export const version = '00';
export const flag = '00';
export const traceparentHeader = 'traceparent';
export const tracestateHeader = 'tracestate';
export const tracestateList = {
  app: 'rx_ui',
};

function _generateTraceId() {
  const u = uuid();
  const traceId = u.replace(/-/g, '').substring(0, 32);
  AppStorage.instance.setToSessionStorage(traceIdStorageKey, traceId);
  return traceId;
}

function _getTraceId() {
  let traceId = AppStorage.instance.getFromSessionStorage(traceIdStorageKey);
  if (!traceId) {
    traceId = _generateTraceId();
  }
  return traceId;
}

function _generateParentId() {
  const u = uuid();
  return u.replace(/-/g, '').substring(0, 16);
}

export function updateTraceId() {
  return _generateTraceId();
}

export function clearTraceId() {
  AppStorage.instance.removeFromSessionStorage(traceIdStorageKey);
}

export function generateTraceHeaders() {
  const traceId = _getTraceId();
  const parentId = _generateParentId();
  return {
    [traceparentHeader]: `${version}-${traceId}-${parentId}-${flag}`,
    [tracestateHeader]: map(tracestateList, (v, k) => `${k}=${v}`).join(','),
  };
}
